<template>
  <div class="pw-opening" aria-label="Pokewudi 开屏动画" @keydown.esc.prevent="finish">
    <div class="opening-stars" aria-hidden="true"></div>
    <div class="opening-brand">
      <div class="opening-orbit" aria-hidden="true">
        <span class="orbit-marker"></span>
        <span v-if="!imageLoaded" class="opening-emblem" aria-hidden="true"></span>
        <img src="/gamestart/logo.png" alt="" @load="imageLoaded = true" />
      </div>
      <div class="opening-kicker">TRAINER ADVENTURE</div>
      <h1>POKEWUDI<span>星域冒险</span></h1>
      <div class="opening-rule" aria-hidden="true"></div>
      <p>新的旅程，等你出发。</p>
    </div>
    <button ref="skip" class="opening-skip" type="button" @click="finish">跳过动画 <span aria-hidden="true">→</span></button>
  </div>
</template>

<script setup>
/* global defineEmits */
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { prefersReducedMotion } from './motion'
const imageLoaded = ref(false)
const emit = defineEmits(['complete'])
const skip = ref(null)
let timer
let complete = false
function finish() {
  if (complete) return
  complete = true
  clearTimeout(timer)
  emit('complete')
}
onMounted(() => {
  if (prefersReducedMotion()) return finish()
  skip.value?.focus({ preventScroll: true })
  timer = setTimeout(finish, 1800)
})
onBeforeUnmount(() => clearTimeout(timer))
</script>

<style scoped>
.pw-opening { position: absolute; inset: 0; z-index: 10000; overflow: hidden; display: grid; place-items: center; color: var(--pw-text); background: #081522; }
.opening-stars { position: absolute; inset: 0; opacity: .65; background: radial-gradient(circle at 20% 25%, #72d4f8 0 1px, transparent 2px), radial-gradient(circle at 75% 70%, #efc982 0 1px, transparent 2px), radial-gradient(circle at 82% 20%, #edf6ff 0 1px, transparent 2px), radial-gradient(ellipse at 50% 38%, #153b50, transparent 58%); }
.opening-brand { position: relative; text-align: center; animation: brand-arrive 600ms var(--pw-ease) both; }
.opening-orbit { position: relative; width: clamp(86px, 21vmin, 180px); height: clamp(86px, 21vmin, 180px); margin: 0 auto 22px; display: grid; place-items: center; border: 1px solid var(--pw-border); border-radius: 50%; }
.opening-orbit::after { content: ''; position: absolute; inset: -9px; border: 1px dashed var(--pw-border); border-radius: 50%; }
.opening-orbit img { width: 80%; filter: drop-shadow(0 8px 20px #0007); }
.orbit-marker { position: absolute; inset: -2px; border-radius: 50%; animation: orbit 1.8s linear; }
.orbit-marker::after { content: ''; position: absolute; width: 7px; height: 7px; top: 0; left: 50%; background: var(--pw-gold); border-radius: 50%; box-shadow: 0 0 12px #efc98280; }
.opening-kicker { color: var(--pw-primary); font-size: 10px; letter-spacing: .28em; }
h1 { margin: 12px 0 0; font-size: clamp(24px, 5vmin, 44px); letter-spacing: .16em; font-weight: 800; }
h1 span { display: block; margin-top: 8px; color: var(--pw-gold); font-size: clamp(12px, 2.4vmin, 19px); letter-spacing: .45em; font-weight: 500; }
.opening-rule { width: 54px; height: 2px; margin: 22px auto 16px; background: var(--pw-primary); }
p { color: var(--pw-muted); font-size: 13px; }
.opening-skip { position: absolute; right: 28px; bottom: 22px; display: flex; align-items: center; gap: 18px; padding: 10px 14px; background: transparent; border: 1px solid var(--pw-border); border-radius: var(--pw-radius-sm); color: var(--pw-muted); font-size: 12px; cursor: pointer; }
@keyframes orbit { to { rotate: 360deg; } }
@keyframes brand-arrive { from { opacity: 0; translate: 0 12px; } to { opacity: 1; translate: 0 0; } }
@media (max-height: 480px) { .opening-orbit { margin-bottom: 12px; } .opening-rule { margin: 12px auto; } .opening-skip { right: 14px; bottom: 12px; } }
@media (prefers-reduced-motion: reduce) { * { animation: none !important; } }
.opening-emblem { position: absolute; width: 52%; height: 52%; top: 24%; left: 24%; border: 2px solid var(--pw-primary); border-radius: 50%; background: linear-gradient(to bottom, var(--pw-primary-strong) 46%, var(--pw-background) 46% 54%, var(--pw-surface-raised) 54%); box-shadow: 0 0 40px rgba(114,212,248,.15); }
.opening-emblem::after { content: ''; position: absolute; top: 38%; left: 38%; width: 24%; height: 24%; box-sizing: border-box; border: 3px solid var(--pw-background); border-radius: 50%; background: var(--pw-gold); }
</style>
